var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.readyToInit)?_c('Popper',{attrs:{"reference":_vm.htmlElement,"disabled":_vm.disabled,"visibleArrow":false,"options":_vm.options,"appendToEl":_vm.appendToEl,"trigger":"hover"}},[_c('div',{staticClass:"k-tooltip",style:({
      backgroundColor: 'var(--tokens-text)',
      color: 'var(--tokens-textInverted)',
      maxWidth: _vm.maxWidth ? _vm.maxWidth : 'calc(100vw - 10px)',
      ..._vm.appearanceOverrides,
    }),attrs:{"dir":"auto"}},[(_vm.text)?[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]:_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }